// extracted by mini-css-extract-plugin
export default {"pageHeadingWrapper":"AdminPageHeader_pageHeadingWrapper__JQ0zr","pageHeading":"AdminPageHeader_pageHeading__ei62a"};